export default "__VITE_ASSET__BduozWv0__"